import { Controller } from "@hotwired/stimulus"

// Autocomplete controller for person and meeting selection
export default class extends Controller {
  static targets = ["input", "hidden", "results", "selected"]
  static values = { 
    url: String,
    minLength: { type: Number, default: 1 }
  }
  
  connect() {
    this.resultsTarget.classList.add("hidden")
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener("click", this.boundClickOutside)
  }
  
  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }
  
  search() {
    const query = this.inputTarget.value.trim()
    
    if (query.length < this.minLengthValue) {
      this.hideResults()
      return
    }
    
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 200)
  }
  
  fetchResults(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)
    
    fetch(url, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(data => {
        this.renderResults(data)
      })
  }
  
  renderResults(items) {
    if (items.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="px-4 py-3 text-sm text-slate-500">No results found</div>
      `
    } else {
      this.resultsTarget.innerHTML = items.map(item => `
        <button type="button" 
                class="w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center justify-between"
                data-action="click->autocomplete#select"
                data-id="${item.id}"
                data-name="${this.escapeHtml(item.name)}"
                data-subtitle="${item.subtitle ? this.escapeHtml(item.subtitle) : ''}">
          <span class="font-medium text-slate-900 truncate flex-1">${this.escapeHtml(item.name)}</span>
          ${item.subtitle ? `<span class="text-slate-500 text-xs ml-2 flex-shrink-0">${this.escapeHtml(item.subtitle)}</span>` : ''}
        </button>
      `).join('')
    }
    this.resultsTarget.classList.remove("hidden")
  }
  
  select(event) {
    const id = event.currentTarget.dataset.id
    const name = event.currentTarget.dataset.name
    const subtitle = event.currentTarget.dataset.subtitle
    
    this.hiddenTarget.value = id
    // Include subtitle in display if present (for meetings with dates)
    this.inputTarget.value = subtitle ? `${name} · ${subtitle}` : name
    
    if (this.hasSelectedTarget) {
      this.selectedTarget.textContent = name
      this.selectedTarget.classList.remove("hidden")
    }
    
    this.hideResults()
    
    // Dispatch change event so listeners can react to selection
    this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
  
  clear() {
    this.hiddenTarget.value = ""
    this.inputTarget.value = ""
    if (this.hasSelectedTarget) {
      this.selectedTarget.classList.add("hidden")
    }
  }
  
  hideResults() {
    this.resultsTarget.classList.add("hidden")
  }
  
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
  
  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}

